// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__oExtD","description":"Services_description__1wL-P","carousel_container":"Services_carousel_container__3nX7Q"};